<template>
  <div>
    <!-- 整单售后 -->
    <baseBreadcrumb :page="$t('message.orderList')" :menu="$t('message.money')"></baseBreadcrumb>
    <div class="modelRow">
      <div class="after-salesNumber">
        <!-- 客户 -->
        <p>
          <span>{{ $t("message.user") }}:</span>
          <span>{{ aftersaleDetailData.porder ? aftersaleDetailData.porder.user.realname : '' }} ({{
            aftersaleDetailData.porder ? aftersaleDetailData.porder.user.id : '' }})</span>
        </p>
        <!-- 售后编号： -->
        <p>
          <span>{{ $t("message.afterSalesNumber") }}:</span>
          <span>{{ aftersaleDetailData.after_sale_sn }}</span>
        </p>
        <!-- 提出人： -->
        <p>
          <span>{{ $t("message.peoplePutForward") }}:</span>
          <span>{{ aftersaleDetailData.created_admin ? aftersaleDetailData.created_admin.realname : "" }}</span>
        </p>
        <!-- 售后类别： -->
        <p>
          <span>{{ $t("message.afterSaleCategory") }}:</span>
          <span>{{ aftersaleDetailData.type_name }}</span>
        </p>
        <!-- 售后状态： -->
        <p>
          <span>{{ $t("message.afterSalesStatus") }}:</span>
          <span>{{ aftersaleDetailData.status_name }}</span>
        </p>
        <!-- 配送单号： -->
        <p>
          <span>{{ $t("message.porderNumber") }}:</span>
          <span>
            <router-link :to="'/porderDetail?porder_sn=' + aftersaleDetailData.porder.porder_sn" target="_blank"
              class="a-link" v-if="aftersaleDetailData.porder">
              {{ aftersaleDetailData.porder ? aftersaleDetailData.porder.porder_sn : "" }}
            </router-link>
          </span>
        </p>
        <!-- 操作人员： -->
        <p>
          <span>{{ $t("message.operators") }}:</span>
          <span class="operatorsList">
            <span>
              <!-- 业务 -->
              {{ $t("message.business") }}:
              {{ aftersaleDetailData.porder && aftersaleDetailData.porder.y_admin ?
                aftersaleDetailData.porder.y_admin.realname : "" }}
            </span>
            <span>
              <!-- 采购 -->
              {{ $t("message.purchase") }}:
              {{ aftersaleDetailData.porder && aftersaleDetailData.porder.g_admin ?
                aftersaleDetailData.porder.g_admin.realname : "" }}
            </span>
            <span>
              <!-- 配货 -->
              {{ $t("message.distribution") }}:
              {{ aftersaleDetailData.porder && aftersaleDetailData.porder.p_admin
                ? aftersaleDetailData.porder.p_admin.realname : "" }}
            </span>
            <!--2023/2/25 接口没有返回贴标人员信息,所以不显示 -->
            <!-- 贴标 -->
            <!-- <span>             
              {{ $t('message.labeling') }}:
              {{ aftersaleDetailData.porder && aftersaleDetailData.porder.y_admin ?
                aftersaleDetailData.porder.y_admin.realname : '' }}
            </span> -->
          </span>
        </p>
        <!-- 配送单汇率： -->
        <p>
          <span>{{ $t("message.deliveryRate") }}:</span>
          <span>
            {{ aftersaleDetailData.porder ? aftersaleDetailData.porder.exchange_rate : "" }}（円/元）</span>
        </p>
        <!-- 问题物流号： -->
        <!-- 2023/3/2 需要 -->
        <p>
          <span>{{ $t("message.problemLogisticsNumber") }}:</span>
          <el-select v-model="aftersaleDetailData.express_no" placeholder="" filterable>
            <el-option v-for='(setItem, setIndex) in express_no_set' :key='setIndex' :label='setItem' :value='setItem'>
            </el-option>
          </el-select>
        </p>
        <!-- 客户界面是否显示： -->
        <p>
          <span>{{ $t("message.whetherTheCustomerInterfaceDisplays") }}:</span>
          <span>
            <!-- 显示 -->
            <el-radio v-model="aftersaleDetailData.is_client_show" :label="1">
              {{ $t("message.display") }}
            </el-radio>
            <!-- 不显示 -->
            <el-radio v-model="aftersaleDetailData.is_client_show" :label="2">
              {{ $t("message.notDisplayed") }}</el-radio>
          </span>
        </p>
        <p>
          <!-- 2023/3/1 这里两个按钮功能还没有,先不做 -->
          <el-button type="primary" class="ChatworkBtn">
            <img :src="require('@/assets/icon/Chatwork.png')" alt="" />
            Chatwork
          </el-button>
          <el-button type="primary" class="Rakuchat">
            <img :src="require('@/assets/icon/Rakuchat.png')" alt="" />
            Rakuchat
          </el-button>
        </p>
      </div>
      <div class="afterSalesReasons">
        <ul class="formBox reasonSelection">
          <!-- 售后原因选择： -->
          <li>
            <span>{{ $t("message.afterSaleReasonSelection") }}:</span>
            <div>
              <el-select v-model="aftersaleDetailData.reason_type" placeholder="" filterable>
                <el-option v-for="item in configReasonList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </li>
          <!-- 业务售后处理意见： -->
          <li>
            <span>{{ $t("message.adviceOnAfterSaleHandlingOfBusiness") }}:</span>
            <div>
              <el-input type="textarea" v-model="after_sale_detail.admin_desc">
              </el-input>
            </div>
          </li>
          <!-- 客户反馈问题： -->
          <li>
            <span>{{ $t("message.customerFeedbackProblem") }}:</span>
            <div>
              <el-input type="textarea" v-model="after_sale_detail.client_desc" placeholder="请输入日文，这是给客户看的">
              </el-input>
            </div>
          </li>
          <!-- 部长课长修改备注 -->
          <!-- 2023/3/2 大榭说部长课长修改备注暂时没有,先空着 -->
          <li>
            <span>
              {{ $t("message.theHeadOfTheMinisterialDivisionRevisedTheRemarks") }}:</span>
            <div>
              <el-input type="textarea" v-model="datas.kk">
              </el-input>(暂无)
            </div>
          </li>
          <!--  入金名义-->
          <li>
            <span>
              {{ $t("message.depositName") }} （客户查看）:</span>
            <div>
              <el-input type="textarea" v-model="aftersaleDetailData.client_bill_reason">
              </el-input>
            </div>
          </li>
        </ul>
        <div class="formBox">
          <!-- 客户反馈问题截图添加： -->
          <div class="imageUpload">
            <h3>
              {{ $t("message.screenshotOfCustomerFeedbackQuestionAdded") }}
            </h3>
            <div class="imageBox">
              <el-upload :action="baseURL + '/api/common/uploadFile'" width="80px" list-type="picture-card"
                :file-list="after_sale_detail.client_images" :on-preview="handlePictureCardPreview"
                :on-remove="handleRemoveY" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccessY">
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
          <!-- 售后处理确认过程截图： -->
          <div class="imageUpload">
            <h3>
              {{ $t("message.screenshotOfAfterSalesProcessConfirmatio") }}
            </h3>
            <div class="imageBox">
              <el-upload :action="baseURL + '/api/common/uploadFile'" width="80px" list-type="picture-card"
                :file-list="after_sale_detail.admin_images" :on-preview="handlePictureCardPreview"
                :on-remove="handleRemoveC" :before-upload="beforeAvatarUpload" :on-success="handleAvatarSuccessC">
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 售后费用调整明细： -->
    <div class="afterSalesCostAdjustmentDetails">
      <h3>
        <!-- 售后费用调整明细 -->
        <span>{{ $t("message.afterSaleExpenseAdjustmentDetails") }}</span>
        <!-- 添加 -->
        <el-button size="mini" type="primary" @click="addData" v-if="aftersaleDetailData.status_name != '已完成'">
          {{ $t("message.add") }}
        </el-button>
      </h3>
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <!-- 费用调整名义 -->
          <li class="flex15">{{ $t("message.nominalCostAdjustment") }}</li>
          <!-- 备注说明 -->
          <li class="flex2">{{ $t("message.remarks") }}</li>
          <!-- 赔款金额（円） -->
          <li>{{ $t("message.amountOfIndemnityYen") }}</li>
          <!-- 收费金额（円） -->
          <li>{{ $t("message.amountCharged") }}</li>
          <!-- 操作 -->
          <li>{{ $t("message.operation") }}</li>
        </ol>
        <ul v-for="(feeItem, feeIndex) in after_sale_detail_fee" :key="feeIndex">
          <li class="flex05">{{ feeIndex + 1 }}</li>
          <!-- 费用调整名义 -->
          <li class="flex15">
            <el-select v-model="feeItem.fee_type" placeholder="" filterable>
              <el-option v-for="item in configFeeType" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </li>
          <!-- 备注说明 -->
          <li class="flex2 textLi">
            <el-input type="textarea" v-model="feeItem.remark"></el-input>
          </li>
          <!-- 赔款金额（円） （这里的单行总计和所有总计使用计算属性totalAmount来完成计算）-->
          <li class="inputLi">
            <input type="text" :disabled="feeItem.f != 0" v-model="feeItem.z"
              oninput="value=value.replace(/[^0-9.]/g,'')" @input="setTotalAmount">

          </li>
          <!-- 收费金额（円） （这里的单行总计和所有总计使用计算属性totalAmount来完成计算）-->
          <li class="inputLi">
            <input type="text" :disabled="feeItem.z != 0" v-model="feeItem.f"
              oninput="value=value.replace(/[^0-9.]/g,'')" @input="setTotalAmount" />
          </li>
          <!-- 操作 -->
          <li>
            <!-- 删除 -->
            <el-button size="mini" type="primary" class="dark" @click="deleteData(feeItem, feeIndex)"
              v-if="aftersaleDetailData.status_name != '已完成'">
              {{ $t("message.delete") }}
            </el-button>
          </li>
        </ul>
        <ul class="totalAdjustmentsText" v-if="after_sale_detail_fee.length">
          <li class="flex05"></li>
          <!-- 费用调整名义 -->
          <li class="flex15"></li>
          <!-- 备注说明 -->
          <li class="flex2 textLi"></li>
          <!-- 赔款金额（円） -->
          <li class="inputLi"></li>
          <!-- 收费金额（円） -->
          <li class="inputLi">
            <!-- 合计调整：円 -->
            {{ $t("message.totalAdjustments") }}:
            {{ totalAmount.totalAdjustments }}円
            <span style="margin-left: 20px;"> {{ totalAmount.totalRMB }}元</span>
          </li>
          <!-- 操作 -->
          <li></li>
        </ul>
        <!-- 暂无数据 -->
        <div v-if="after_sale_detail_fee == false" class="No_data">
          {{ $t("message.noDataYet") }}
        </div>
      </div>
      <!-- 售后费用调整明细操作栏 -->
      <div class="afterSalesCostAdjustmentDetailsOperate">
        <!-- 添加赔款单 -->
        <el-button type="success" size="mini" @click="addAClaimNote" v-if="isAuth(346)">
          {{ $t("message.addAClaimNote") }}
        </el-button>
        <span v-if="aftersaleDetailData.status_name != '已完成'" style="margin-left: 20px;">
          <!-- 修改 -->
          <el-button type="primary" size="mini" class="primary" @click="porderWholeUpdate" v-if="isAuth(337)">
            {{ $t("message.edit") }}
          </el-button>
          <!-- 删除 -->
          <el-button type="primary" size="mini" class="dark" @click="afterSaleDelete" v-if="isAuth(345)">
            {{ $t("message.delete") }}
          </el-button>
          <!-- 确认 -->
          <!-- 2023/3/2 权限配置还没有先不做 -->
          <el-button type="primary" size="mini" @click="porderWholeConfirm" v-if="isAuth(338)">
            {{ $t("message.confirm") }}
          </el-button>
          <!-- 完成 -->
          <el-button type="primary" size="mini" class="primary" @click="porderWholeComplete" v-if="isAuth(339)">
            {{ $t("message.complete") }}
          </el-button>
        </span>

      </div>
    </div>

    <!-- 赔款单信息 -->
    <div class="indemnityStatementInformation" v-for="(iSIItem, iSIIndex) in reparations" :key="iSIIndex">
      <div class="indemnityBill">
        <!--文本: 赔款单号 -->
        <h3>
          <span>{{ $t("message.claimNumber") }}：{{ iSIItem.reparation_sn }}</span><span>状态：{{ iSIItem.status_name
          }}</span>
        </h3>
        <div class="infoBoxGroup">
          <ul class="infoBox">
            <!-- 提出时间 -->
            <li>
              <label>{{ $t("message.forwardTime") }}</label>
              <div>{{ iSIItem.created_at }}</div>
            </li>
            <!-- 提出人 -->
            <li>
              <label>{{ $t("message.peoplePutForward") }}</label>
              <div>
                {{ iSIItem.created_admin.realname }}
                <!-- 2023/3/1 不确定要不要加id -->
                <!-- {{ iSIItem.created_admin.id }} -->
              </div>
            </li>
            <!-- 确认时间 -->
            <li>
              <label>{{ $t("message.acknowledgingTime") }}</label>
              <div>{{ iSIItem.confirm_at }}</div>
            </li>
            <!-- 确认人 -->
            <li>
              <label>{{ $t("message.affirmName") }}</label>
              <div>{{ iSIItem.confirm_admin ? iSIItem.confirm_admin.realname : '' }}</div>
            </li>
            <!-- 赔款上限 -->
            <!-- 2023/2/27 这里需要等待确认规则再接,现在还没定显示什么 -->
            <li>
              <label>{{ $t("message.compensationCap") }}</label>
              <div>赔款上限(暂无)</div>
            </li>
            <!-- 具体赔款原因 -->
            <li>
              <label>{{ $t("message.reasonForCompensation") }}</label>
              <div>
                <el-input type="textarea" v-model="iSIItem.reason">
                </el-input>
              </div>
            </li>
          </ul>
          <ul class="infoBox">
            <!-- 赔款类别 -->
            <li>
              <label>
                {{ $t("message.compensationCategory") }}
              </label>
              <div>

                <el-select filterable v-model="iSIItem.reparation_reason" size="mini" placeholder="请选择">
                  <el-option v-for="item in iSIItem.reparationReasonList" :label="item" :value="item" :key="item">
                  </el-option>
                </el-select>
              </div>
            </li>
            <!-- 赔款数量 -->
            <li>
              <label>
                {{ $t("message.amountOfIndemnity") }}
              </label>
              <div> <el-input v-model="iSIItem.reparation_num" size="mini" placeholder="请输入"
                  @blur="getReparationsByUser(iSIItem, iSIIndex)"></el-input></div>
            </li>
            <!-- 赔款类型 -->
            <li>
              <label>
                {{ $t("message.theOrganizationOfTheResponsiblePerson") }}
              </label>
              <div>
                <el-select filterable v-model="iSIItem.reparation_type" size="mini"
                  @change="getReparationsByUser(iSIItem, iSIIndex)" placeholder="请选择">
                  <el-option v-for="item in reparationType" :label="item.value" :value="item.value" :key="item.value">
                  </el-option>
                </el-select>
              </div>
            </li>
            <!-- 责任人类别 -->
            <li class="categoryOfResponsiblePersonBox">
              <label>{{ $t("message.categoryOfResponsiblePerson") }}</label>
              <div>
                <p>
                  <!-- 公司员工 -->
                  <el-radio @change="clearDataLiableType(iSIItem, iSIIndex)" v-model="iSIItem.liable_type" :label="1">
                    {{ $t("message.companyEmployees") }}
                  </el-radio>
                  <!--文本: 责任人选择 -->
                  <el-select filterable v-if="iSIItem.liable_type == 1" v-model="iSIItem.liable_content_name"
                    :placeholder="$t('message.selectionOfResponsiblePersons')" size="mini"
                    @change="setzhuTi(iSIItem, iSIIndex);">
                    <el-option v-for="item in accountList" :label="item.realname" :value="item.id" :key="item.id">
                    </el-option>
                  </el-select>
                  <el-select disabled v-model="nullData" v-else
                    :placeholder="$t('message.selectionOfResponsiblePersons')" size="mini">
                  </el-select>
                </p>
                <p>
                  <!-- 外部物流公司 -->
                  <el-radio @change="clearDataLiableType(iSIItem, iSIIndex)" v-model="iSIItem.liable_type" :label="2">
                    {{ $t("message.externalLogisticsCompanies") }}
                  </el-radio>
                  <!--文本: 请输入物流号 -->
                  <el-select filterable v-model="iSIItem.liable_content_wuliu" placeholder="物流公司" size="mini"
                    @change="setzhuTi(iSIItem, iSIIndex);" :disabled="iSIItem.liable_type != 2">
                    <el-option v-for="item in logisticsList" :label="item.name" :value="item.name" :key="item.id">
                    </el-option>
                  </el-select>
                </p>
                <p>
                  <!-- 第三方卖家 -->
                  <el-radio @change="clearDataLiableType(iSIItem, iSIIndex)" v-model="iSIItem.liable_type" :label="3">
                    {{ $t("message.thirdPartySellers") }}
                  </el-radio>
                  <!--文本: 请输入物流号 -->
                  <el-input placeholder="请输入店铺名" @input="setzhuTi(iSIItem, iSIIndex)" v-if="iSIItem.liable_type == 3"
                    v-model="iSIItem.liable_content_maijia" size="mini"></el-input>
                  <el-input v-model="nullData" v-else disabled size="mini" placeholder="请输入"></el-input>
                </p>
              </div>
            </li>

          </ul>
        </div>
      </div>
      <!-- 承担费用明细 -->
      <div class="detailsOfExpensesToBear">
        <h3>
          <!-- 添加 -->
          <el-button type="primary" size="mini" @click="addReparationData(iSIItem.reparation_amount)"
            v-if="isAuth(346)">{{ $t("message.add")
            }}</el-button>
        </h3>
        <!-- 赔款金额 -->
        <div class="total">
          <div class="item"> 理应赔款金额：<el-input v-model="iSIItem.should_amount"
              @input="iSIItem.shouldAmountEdited = true"></el-input> 元</div>
          <div class="item">
            实际赔款金额：<el-input v-model="iSIItem.actual_amount"></el-input>元
          </div>
          <div class="item">团队赔款：<el-input v-model="iSIItem.team_amount" type="number" min="0"
              step="0.01" @input="iSIItem.teamAmountEdited = true"></el-input>元</div>
        </div>
        <div class="table">
          <ol>
            <!-- 文本: 赔款明细 -->
            <li>{{ $t("message.compensationDetails") }}</li>
            <!-- 文本: 责任人选择 -->
            <li>{{ $t("message.responsiblePerson") }}</li>
            <!-- 文本: 责任人角色 -->
            <li>{{ $t("message.responsiblePersonRole") }}</li>
            <!-- 费用承担-->
            <li>费用承担</li>
            <!-- 文本: 操作 -->
            <li>{{ $t("message.operation") }}</li>
          </ol>
          <!-- 责任承担人行 -->
          <ul v-for="(reparationItem, reparationIndex) in iSIItem.reparation_amount"
            :key="reparationIndex + 'reparationIndex'">
            <!-- 责任人选择 -->
            <li style="background: white;">
              <span v-if='reparationItem.type == 2'>
                {{ $t('message.associatedResponsiblePerson') + (reparationIndex) }}</span>
              <span v-else> 主责任人</span>
            </li>
            <!--  责任人 -->
            <li>
              <!-- 主责任人类型为责任承担人(reparationItem.type == 1)时根据左侧责任人类别(iSIItem.liable_type)显示不同的值 -->
              <el-select filterable v-model="reparationItem.main" placeholder="" size="mini"
                v-if="reparationItem.type != 3 && reparationItem.main != '公司'">
                <el-option v-for="item in accountList" :label="item.realname" :value="item.id" :key="item.id">
                </el-option>
              </el-select>
              <span v-else>{{ reparationItem.main }}</span>
            </li>
            <!--  责任人角色 -->
            <!-- 选择了关联责任人才会有responsiblePersonRole参数,否则显示'-' -->
            <li>{{ setresponsiblePersonRole(reparationItem) }}</li>
            <!-- 文本: 承担金额（元） -->
            <li> <input type="text" v-model="reparationItem.amount" class="should_amount"
                @input="amountTotal(iSIItem.reparation_amount, iSIIndex)"></li>
            <!-- 文本: 操作 -->
            <li>
              <!-- 文本: 删除 -->
              <!-- 删除按钮只能操作关联责任人数据行 -->
              <el-button size="mini" type="primary" class="dark"
                @click=" deleteReparationData(iSIItem.reparation_amount, reparationIndex, iSIIndex)"
                v-if="reparationItem.type == 2">
                {{ $t("message.delete") }}
              </el-button>
            </li>
          </ul>

        </div>
        <!-- 承担费用明细的操作栏 -->
        <div class="bearTheCostBreakdownOperation">
          <!-- 删除 -->
          <el-button type='primary' size="mini" class="dark" @click="deleteReparation(iSIItem, iSIIndex)"
            v-if="isAuth(345)">
            {{ $t('message.delete') }}
          </el-button>
          <!-- 保存 -->
          <!-- 新增的赔款单使用保存按钮保存 -->
          <el-button v-if="iSIItem.status == 0 && isAuth(347)" @click="storeReparation(iSIItem)" type='primary'
            size="mini" class="primary">
            {{ $t('message.save') }}
          </el-button>
          <!-- 修改 -->
          <!-- 已有的赔款单数据使用修改按钮保存修改 -->
          <el-button v-if="iSIItem.status != 0 && isAuth(347) && iSIItem.status_name != '已确认'" type='primary'
            size="mini" @click="updateReparation(iSIItem)" class="primary">{{ $t('message.edit')
            }}</el-button>
          <!-- 赔款确认 -->
          <!--2023/3/2 赔款确认按钮只有部长展示，系统里需要权限配置,现在还没有权限所以没配置
          只有已保存待确认的赔款单才可以点击赔款确认按钮 -->
          <el-button size="mini" type='primary' v-if="iSIItem.status == 1 && isAuth(348)"
            @click="confirmReparation(iSIItem)">
            {{ $t('message.confirmationOfCompensation') }}</el-button>
        </div>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="imgDialogVisible">
      <img :src="dialogImageUrl" alt="" />
    </el-dialog>
    <!-- 出入金预览 -->
    <previewOfDepositAndWithdrawal ref="previewOfDepositAndWithdrawal" :tableData="billPreviewList" showConfirm
      @confirm="submitPorderWholeComplete" />
  </div>
</template>

<script>
import { transferDate } from "../../../utlis/date";
import { mapState } from "vuex";
import { reparationType } from '@/utlis/options'
import previewOfDepositAndWithdrawal from '../../problemDetail/components/previewOfDepositAndWithdrawal'
export default {
  data() {
    return {
      reparationType,

      datas: {
        after_sale_sn: this.$route.query.after_sale_sn,
      },
      aftersaleDetailData: {

      }, //售后单详情
      configReasonList: [], //售后原因列表 售后原因就是调整原因
      after_sale_detail: {}, //整个单子的售后原因信息
      after_sale_detail_fee: [], //售后费用调整明细列表
      configFeeType: [], //金额调整原因列表
      reparations: [], //赔款单信息
      accountList: [], //员工账户列表
      nullData: null,//占位参数
      express_no_set: [],//问题物流单号列表
      exchange_rate: 0,
      dialogImageUrl: '',
      imgDialogVisible: false,
      totalRMB: 0,//实际赔款总数
      totalAmount: {
        Compensation: '',
        totalAdjustments: '',
        totalRMB: '',
      },
      billPreviewList: [],//出入金预览
    };
  },
  components: {
    previewOfDepositAndWithdrawal
  },
  computed: {

    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,

    }),
  },

  created() {
    this.$store.dispatch("getLogisticsList"); //物流方式获取
    this.aftersaleDetail();
    this.getconfigReasonList();
    this.configFeeTypeList();
    this.accountNumberList();

  },
  methods: {
    // 获取赔款类型选项
    reparationReason(index, liable_content = '', keepSelected = false) {
      const reparation_reason = this.reparations[index].reparation_reason
      if (!keepSelected) {
        this.reparations[index].reparation_reason = ''
      }
      this.$api.capitalApi
        .reparationReason({ liable_content }).then(res => {
          this.reparations[index].reparationReasonList = Array.isArray(res.data) ? res.data : []
          if (keepSelected) {
            this.reparations[index].reparation_reason = reparation_reason
          }
          this.$forceUpdate()
        })
    },
    validateReparationReason(data) {
      if (data.reparationReasonList && data.reparationReasonList.length && !data.reparation_reason) {
        this.$message.error('赔款类别未选择')
        return false
      }
      return true
    },
    // 售后费用调整明细列表金额统计
    setTotalAmount() {
      let Compensation = 0;
      let totalAdjustments = 0;
      this.after_sale_detail_fee.forEach((detailFeeItem) => {
        detailFeeItem.amount = detailFeeItem.z - detailFeeItem.f + 0;
        Compensation += Math.abs(Math.min(Number(detailFeeItem.amount || 0), 0)); //规则:绝对值(0或者负数),因为计算的是所有赔款总数
        totalAdjustments += Number(detailFeeItem.amount);
      });

      // 售后费用调整明细列表金额统计
      this.totalAmount = {
        Compensation: parseInt(Compensation) || 0, //合计赔款金额 (日元舍弃小数)
        totalAdjustments: parseInt(totalAdjustments) || 0, //合计调整 (日元舍弃小数)
        totalRMB: parseInt(totalAdjustments / this.exchange_rate) || 0, //合计调整 (日元舍弃小数)
      };
      this.reparations.forEach(item => {
        // 新建整单赔款时默认取业务填写的赔款总额，人工修改后不再覆盖。
        if (!item.shouldAmountEdited) {
          item.should_amount = this.totalAmount.totalRMB
        }
        item.shouldTotal = this.totalAmount.totalRMB
      })
    },
    // 根据理应赔款计算金额
    getReparationsByUser(item, index) {
      let datas = {
        userName: item.liable_content_name ? this.accountList.find(items => items.id == item.liable_content_name).realname : '',
        shouleMoney: item.shouldTotal,
        type: item.reparation_type,
        numbers: item.reparation_num
      }
      if (datas.userName == '' || datas.type == '' || datas.numbers === '') {
        return false
      }
      this.reparations[index].reparation_amount = []

      this.$api.capitalApi.getReparationsByUser(datas).then((res) => {
        if (res.errcode == 1) return false
        res.data.peikuan.forEach(item => {
          if (item.name == '公司') {
            this.reparations[index].reparation_amount.push({
              main: item.name,
              rate: 1,
              amount: item.amount,
              type: '2',
              name: item.name,
              should_amount: 0,
            })
          } else {
            let nameData = this.accountList.find(items => items.realname == item.name)
            this.reparations[index].reparation_amount.push({
              main: nameData ? nameData.id : '',
              rate: 1,
              amount: item.amount,
              type: nameData.realname == datas.userName ? '1' : '2',
              name: nameData.role[0].name,
              should_amount: nameData.realname == datas.userName ? this.reparations[index].shouldTotal : 0,
            })
          }
        })
        this.amountTotal(item.reparation_amount, index)

        // this.allTotal()
      })
    },
    // 关闭当前页面
    ClosePage() {
      if (navigator.userAgent.indexOf("MSIE") > 0) {
        if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
          window.opener = null; window.close();
        } else {
          window.open('', '_top'); window.top.close();
        }
      } else if (navigator.userAgent.indexOf("Firefox") > 0) {
        window.location.href = 'about:blank ';
        //火狐默认状态非window.open的页面window.close是无效的
        //window.history.go(-2);
      } else {
        window.opener = null;
        window.open('', '_self', '');
        window.close();
      }
    },
    // 售后-整单-完成
    porderWholeComplete() {
      this.$confirm(
        this.$t("message.afterSaleConfirmationMethod"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.completeDirectly"),
          cancelButtonText: this.$t("message.entryAndExitPreview"),
          distinguishCancelAndClose: true,
          type: "warning",
          center: true,
        }
      ).then(() => {
        this.submitPorderWholeComplete();
      }).catch((action) => {
        if (action == 'cancel') this.submitPorderWholeComplete(true);
      });
    },
    // 售后完成；预览时才传 preview_bill，预览弹框确认时不传。
    submitPorderWholeComplete(preview = false) {
      const datas = { after_sale_sn: this.aftersaleDetailData.after_sale_sn };
      if (preview) datas.preview_bill = 1;
      this.$api.capitalApi.porderWholeComplete(datas).then(res => {
        if (res.code != 0) return this.$message.error(res.data.msg)
        if (preview) {
          this.billPreviewList = res.data;
          this.billPreviewList.forEach(item => {
            item.adjust_detail = JSON.parse(item.adjust_detail);
          });
          this.$refs.previewOfDepositAndWithdrawal.dialogVisible = true;
          return;
        }
        this.$refs.previewOfDepositAndWithdrawal.dialogVisible = false;
        this.aftersaleDetail()
        this.$message.success(this.$t('message.operationSucceeded'))
      })
    },
    // 售后-整单-确认
    porderWholeConfirm() {
      this.$confirm(
        this.$t("message.doYouConfirm"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      ).then(() => {
        this.$api.capitalApi
          .porderWholeConfirm({ after_sale_sn: this.aftersaleDetailData.after_sale_sn }).then(res => {
            if (res.code != 0) return this.$message.error(res.data.msg)
            this.aftersaleDetail()
            this.$message.success(this.$t('message.operationSucceeded'))
          })
      })
    },
    // 售后-售后单删除(不区分售后单类型)
    afterSaleDelete() {
      this.$confirm(
        // 文本:是否确认删除
        this.$t("message.whetherToConfirmTheDeletion"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      ).then(() => {
        this.$api.capitalApi
          .afterSaleDelete({ after_sale_sn: this.aftersaleDetailData.after_sale_sn }).then(res => {
            ////console.log('事件名',res)
            if (res.code != 0) return this.$message.error(res.data.msg)
            //接下来的操作        
            // this.aftersaleDetail()
            // 文本:操作成功
            this.$message.success(this.$t('message.operationSucceeded'))
            this.ClosePage()
          })
      })
    },
    // 售后-整单-修改
    porderWholeUpdate() {
      if (!this.aftersaleDetailData.client_bill_reason) return this.$message.error('入金名义（客户查看),不能为空')
      this.$confirm(
        // 文本:是否确认修改
        this.$t("message.whetherToConfirmTheModification"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      ).then(() => {

        // 拼装数据
        let upData = {
          after_sale_sn: this.aftersaleDetailData.after_sale_sn,//	售后单号
          porder_sn: this.aftersaleDetailData.porder_sn,//配送单号
          express_no: this.aftersaleDetailData.express_no,//国际物流号
          is_client_show: this.aftersaleDetailData.is_client_show,//是否客户界面显示
          reason_type: this.aftersaleDetailData.reason_type,//售后原因
          client_desc: this.aftersaleDetailData.after_sale_detail[0].client_desc,//客户反馈问题
          client_images: this.assemblePictures(this.aftersaleDetailData.after_sale_detail[0].client_images),//客户反馈问题图片 因为过去的时候转化成组件需要的数据格式了,传入接口的时候需要转化为接口需要的数据格式
          admin_desc: this.aftersaleDetailData.after_sale_detail[0].admin_desc,//售后处理意见
          admin_images: this.assemblePictures(this.aftersaleDetailData.after_sale_detail[0].admin_images),//售后处理意见 因为过去的时候转化成组件需要的数据格式了,传入接口的时候需要转化为接口需要的数据格式
          fee_list: this.after_sale_detail_fee,
          client_bill_reason: this.aftersaleDetailData.client_bill_reason,
        }

        this.$api.capitalApi
          .porderWholeUpdate(upData).then(res => {
            ////console.log('事件名',res)
            if (res.code != 0) return this.$message.error(res.data.msg)
            //接下来的操作        
            // this.aftersaleDetail()
            // 文本:操作成功
            this.$message.success(this.$t('message.operationSucceeded'))
          })
      })

    },
    // 确认单个赔款单
    confirmReparation(data) {
      this.$confirm(
        // 文本:是否确认该赔款单
        this.$t("message.whetherToConfirmTheClaimNote"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      ).then(() => {
        this.$api.capitalApi
          .confirmReparation({ reparation_sn: data.reparation_sn }).then(res => {
            ////console.log('事件名',res)
            if (res.code != 0) return this.$message.error(res.data.msg)
            //接下来的操作        

          })
      });
    },
    // 单个赔款单的删除数据保存操作
    deleteReparation(data, index) {
      this.$confirm(
        // 文本:是否确认删除
        this.$t("message.whetherToConfirmTheDeletion"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      ).then(() => {
        // 假如还没有提出就直接删除赔款单
        if (data.status == 0) {
          // this.aftersaleDetail()
          this.reparations.splice(index, 1)
          // 文本:删除成功
          this.$message.success(this.$t('message.successfullyDeleted'))
        } else {
          this.$api.capitalApi
            .deleteReparation({ reparation_sn: data.reparation_sn }).then(res => {
              ////console.log('事件名',res)
              if (res.code != 0) return this.$message.error(res.data.msg)
              //接下来的操作        
              // this.aftersaleDetail()
              this.reparations.splice(index, 1)
              // 文本:删除成功
              this.$message.success(this.$t('message.successfullyDeleted'))
            })
        }

      });



    },
    // 赔款单的添加数据保存操作
    storeReparation(data) {
      // 拼一下数据格式,因为接口需要兼容单个商品售后单所以数据格式和详情接口不一样
      // if (!data.reparation_reason) return this.$message.error('未选择赔款类别')
      if (!this.validateReparationReason(data)) return
      let updata = {
        reparation_sn: data.reparation_sn,
        liable_type: data.liable_type,
        liable_content: '',
        reason: data.reason,
        reparation_type: data.reparation_type,
        reparation_num: data.reparation_num,
        reparation_reason: data.reparation_reason,
        afterSaleDetailSet: [{
          id: this.aftersaleDetailData.after_sale_detail[0].id, //这个id需要拿售后单详情接口的售后单id
          rate: 100 //这里固定传100
        }],
        reparationList: data.reparation_amount,
        should_amount: data.should_amount,
        actual_amount: data.actual_amount,
        team_amount: data.team_amount,
      }
      if (updata.liable_type == 1) {
        updata.liable_content = data.liable_content_name
      } else if (updata.liable_type == 2) {
        updata.liable_content = data.liable_content_wuliu
      } else if (updata.liable_type == 3) {
        updata.liable_content = data.liable_content_maijia
      }
      this.$api.capitalApi
        .storeReparation(updata).then(res => {
          ////console.log('事件名',res)
          if (res.code != 0) return this.$message.error(res.data.msg)
          //接下来的操作        
          this.aftersaleDetail()
        })
    },
    // 赔款单的修改数据保存操作
    updateReparation(data) {
      // 拼一下数据格式,因为接口需要兼容单个商品售后单所以数据格式和详情接口不一样
      // if (!data.reparation_reason) return this.$message.error('未选择赔款类别')
      if (!this.validateReparationReason(data)) return
      let updata = {
        reparation_sn: data.reparation_sn,
        liable_type: data.liable_type,
        liable_content: '',
        reason: data.reason,
        reparation_type: data.reparation_type,
        reparation_num: data.reparation_num,
        reparation_reason: data.reparation_reason,
        afterSaleDetailSet: [{
          id: this.aftersaleDetailData.id, //这个id需要拿售后单详情接口的售后单id
          rate: 100 //这里固定传100
        }],
        reparationList: data.reparation_amount,
        should_amount: data.should_amount,
        actual_amount: data.actual_amount,
        team_amount: data.team_amount,
      }
      if (updata.liable_type == 1) {
        updata.liable_content = data.liable_content_name
      } else if (updata.liable_type == 2) {
        updata.liable_content = data.liable_content_wuliu
      } else if (updata.liable_type == 3) {
        updata.liable_content = data.liable_content_maijia
      }
      this.$api.capitalApi
        .updateReparation(updata).then(res => {
          ////console.log('事件名',res)
          if (res.code != 0) return this.$message.error(res.msg)
          this.$message.success(res.msg)
          //接下来的操作
        })
    },
    // 显示左侧责任人所在组织
    setZeRenRenJueSe(iSIItem) {
      let responsiblePersonRole = ''
      // 假如已经获取到了员工账户列表并且责任主体类型为1就根据id获取责任人所在组织
      if (this.accountList.length && iSIItem.liable_type == 1) {
        responsiblePersonRole = this.accountList.find((account) => { return account.id == iSIItem.liable_content_name }) ? this.accountList.find((account) => { return account.id == iSIItem.liable_content_name }).role[0].name : ''
      }
      return responsiblePersonRole
    },
    // 把选择的关联责任人的角色(部门+职位)显示出来
    setresponsiblePersonRole(item) {
      let responsiblePersonRole = ''
      // 假如已经获取到了员工账户列表和当前行类型为关联责任人就根据id获取关联责任人所在组织
      if (this.accountList.length && (item.type == 2 || item.type == 1) && item.main != '公司') {

        let main = this.accountList.find((account) => account.id == item.main)
        if (main) {
          responsiblePersonRole = main.role[0].name
        } else {
          responsiblePersonRole = ''
        }

      } else {
        responsiblePersonRole = item.main
      }
      return responsiblePersonRole

      item.responsiblePersonRole = this.accountList.find((account) => { return account.id == value }).role[0].name
    },
    // 左侧责任人选择关联到右侧表格第一行责任承担人
    setzhuTi(iSIItem, iSIIndex) {
      let rightList = iSIItem.reparation_amount;
      this.reparations[iSIIndex].reparation_amount = []
      // 根据不同责任人类别把liable_content赋值到右侧列表第一行里
      switch (iSIItem.liable_type) {
        case 1: //责任人类别为公司员工时把liable_content赋值到右侧main里
          this.getReparationsByUser(iSIItem, iSIIndex)

          // 查找当前的赔款类别
          this.reparationReason(iSIIndex, rightList != false ? rightList[0].main : iSIItem.liable_content_name
          )
          if (iSIItem.reparation_amount == false) return false
          rightList[0].main = iSIItem.liable_content_name

          break;
        case 2: //责任人类别为外部物流公司时把liable_content直接赋值到右侧main里
          this.reparations[iSIIndex].reparation_amount.push({
            reparation_sn: "", //物流单号
            type: 3, //赔款主体类型 1:主要责任人 2:关联责任人 3:公司
            main: iSIItem.liable_content_wuliu, //赔款主体内容
            rate: 1, //赔款比例
            amount: iSIItem.shouldTotal, //赔款金额
            should_amount: iSIItem.shouldTotal,
            // main_name: "",
          })
          this.amountTotal(this.reparations[iSIIndex].reparation_amount, iSIIndex)

          break;
        case 3: //责任人类别为第三方卖家时把liable_content赋值到右侧main
          this.reparations[iSIIndex].reparation_amount.push({
            reparation_sn: "", //物流单号
            type: 3, //赔款主体类型 1:主要责任人 2:关联责任人 3:公司
            main: iSIItem.liable_content_maijia, //赔款主体内容
            rate: 1, //赔款比例
            amount: iSIItem.shouldTotal, //赔款金额
            should_amount: iSIItem.shouldTotal,
            // main_name: "",
          })
          this.amountTotal(this.reparations[iSIIndex].reparation_amount, iSIIndex)

          break;
        default:
          break;
      }
    },
    // 清除已选中的数据和右侧表格责任承担人的数据
    clearDataLiableType(item, index) {
      let rightList = item.reparation_amount;
      this.reparations[index].reparation_amount = []
      switch (item.liable_type) {
        case 1: //责任人类别为公司员工时把liable_content赋值到右侧main里
          this.getReparationsByUser(item, index)
          if (item.reparation_amount == false) return false
          rightList[0].main = item.liable_content_name


          break;
        case 2: //责任人类别为外部物流公司时把liable_content直接赋值到右侧main里
          this.reparations[index].reparation_amount.push({
            reparation_sn: "", //物流单号
            type: 3, //赔款主体类型 1:主要责任人 2:关联责任人 3:公司
            main: item.liable_content_wuliu, //赔款主体内容
            rate: 1, //赔款比例
            amount: item.shouldTotal, //赔款金额
            should_amount: item.shouldTotal,
            // main_name: "",
          })
          this.amountTotal(item.reparation_amount, index)

          break;
        case 3: //责任人类别为第三方卖家时把liable_content赋值到右侧main
          this.reparations[index].reparation_amount.push({
            reparation_sn: "", //物流单号
            type: 3, //赔款主体类型 1:主要责任人 2:关联责任人 3:公司
            main: item.liable_content_maijia, //赔款主体内容
            rate: 1, //赔款比例
            amount: item.shouldTotal, //赔款金额
            should_amount: item.shouldTotal,
            // main_name: "",
          })
          this.amountTotal(item.reparation_amount, index)
          break;
        default:
          break;
      }
      this.$forceUpdate()
    },

    // 添加赔款单列表数据
    addReparationData(list) {
      list.splice(1, 0, {
        type: 2,
        rate: 1,
        amount: 0,
        should_amount: 0,
      });
    },
    // 删除赔款单右侧承担费用明细列表数据
    deleteReparationData(list, index, iSIIndex) {
      this.$confirm(
        // 文本:是否确认删除
        this.$t("message.whetherToConfirmTheDeletion"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      ).then(() => {
        list.splice(index, 1);
        this.amountTotal(list, iSIIndex)//重新计算公司承担的赔款比例
      });
    },
    // 添加赔款单数据
    async addAClaimNote() {
      let createUserInfomation = JSON.parse(localStorage.getItem('japanUserRoleInfo'))
      let created_name = createUserInfomation.realname
      let created_id = createUserInfomation.id
      console.log(this.aftersaleDetailData);
      // 获取新的赔款单号
      this.$api.capitalApi
        .getNewReparationSn()
        .then((res) => {
          console.log('事件名', res)
          if (res.code != 0) return this.$message.error(res.data.msg);
          this.reparations.push(
            {
              reparation_sn: res.data, //赔款单号
              status: 0, //赔款单状态值
              status_name: "未提出", //赔款单状态名
              liable_type: 1, //责任主体类型
              liable_content: "", //责任主体内容
              reason: '', // 赔款单原因
              reparation_num: 0,
              reparation_type: '默认',
              reparation_reason: '',
              reparationReasonList: [],
              created_admin: {
                id: created_id,
                realname: created_name,
              }, //提出者
              confirm_admin: null, //确认者
              created_at: transferDate(new Date()), //提出时间
              confirm_at: null, //确认时间
              reparation_amount: [
                // {
                //   reparation_sn: "", //物流单号
                //   type: 2, //赔款主体类型 1:主要责任人 2:关联责任人 3:公司
                //   // main: "", //赔款主体内容
                //   rate: 0, //赔款比例
                //   amount: 0, //赔款金额
                //   should_amount: 0,
                //   // main_name: "",
                // },//固定生成字段,代表责任主体人,不能更改类型

              ], //赔款明细
              totalRMB: 0,
              should_amount: this.totalAmount.totalRMB,
              shouldAmountEdited: false,
              actual_amount: 0,
              team_amount: 0,
              teamAmountEdited: false,
              shouldTotal: this.totalAmount.totalRMB,
            },
          );
          //接下来的操作
          this.reparationReason(this.reparations.length - 1)
          return res.data;
        });
    },
    // 获取员工列表
    accountNumberList() {
      this.$api.roleApi
        .accountNumberList({
          pageSize: 9999,
          forSelect: 1
        })
        .then((res) => {
          ////console.log('事件名',res)
          if (res.code != 0) return this.$message.error(res.data.msg);
          //接下来的操作
          this.accountList = res.data.data;
          // 把i的转化为字符型,因为详情借口返回的是字符型,这里是数值型
          res.data.data.forEach((element) => {
            element.id = element.id + "";
          });
        });
    },
    handleRemoveY(file, fileList) {
      this.after_sale_detail.client_images = fileList;
    },
    handleAvatarSuccessY(res, file, fileList) {
      this.after_sale_detail.client_images = fileList;
    },
    handleRemoveC(file, fileList) {
      this.after_sale_detail.admin_images = fileList;
    },
    handleAvatarSuccessC(res, file, fileList) {
      this.after_sale_detail.admin_images = fileList;
    },
    handlePictureCardPreview(file) {
      console.log(file)
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    getFileName(url) {
      let str = url.split("/");
      // str = str.slice(str.length - 1, str.length).toString(String).split(".");
      str = str.slice(str.length - 1, str.length);
      return str[0];
    },
    // 获取售后单详情
    aftersaleDetail() {
      this.$api.capitalApi.aftersaleDetail(this.datas).then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        //接下来的操作
        this.aftersaleDetailData = res.data;
        this.exchange_rate = res.data.porder.exchange_rate
        this.express_no_set = res.data.porder.express_no_set
        // 把图片列表转化为组件需要的格式
        let tiHuan = [];
        for (const i in res.data.after_sale_detail[0].client_images) {
          const imgitem = res.data.after_sale_detail[0].client_images[i];
          tiHuan.push({ name: this.getFileName(imgitem), url: imgitem });
        }
        let tiHuanC = [];
        for (const i in res.data.after_sale_detail[0].admin_images) {
          const imgitem = res.data.after_sale_detail[0].admin_images[i];
          tiHuanC.push({ name: this.getFileName(imgitem), url: imgitem });
        }
        // 2023/2/27 赋予赔款数量和收费金额数值,因为接口返回只有amount一个参数,但是页面上有两个显示的框(单番商品售后详情也是这样做的所以只能这样做,因为用的同一个接口)
        // 2023/2/27 拆分的数据在修改输入框时计算改变amount
        if (
          res.data.after_sale_detail[0] &&
          res.data.after_sale_detail[0].after_sale_detail_fee
        ) {
          res.data.after_sale_detail[0].after_sale_detail_fee.forEach(
            (detailFeeItem) => {
              detailFeeItem.z = Number(Math.max(detailFeeItem.amount, 0));
              detailFeeItem.f = Number(
                Math.abs(Math.min(detailFeeItem.amount, 0))
              );
            }
          );
        }
        // 将接口返回的数据拆分
        this.after_sale_detail = res.data.after_sale_detail[0];
        this.after_sale_detail_fee =
          res.data.after_sale_detail[0].after_sale_detail_fee;

        this.setTotalAmount()
        this.reparations = res.data.reparations
        // 计算赔款单的总价
        res.data.reparations.forEach((item, index) => {
          // 已有赔款单保留接口返回的理应赔款，修改提交时不再重算。
          item.shouldAmountEdited = true
          item.shouldTotal = this.totalAmount.totalRMB
          item.team_amount = item.team_amount == null ? '' : item.team_amount
          item.teamAmountEdited = true
          // this.amountTotal(item.reparation_amount, index)
          if (item.liable_type == 1) {
            item.liable_content_name = item.liable_content
          } else if (item.liable_type == 2) {
            item.liable_content_wuliu = item.liable_content
          } else if (item.liable_type == 3) {
            item.liable_content_maijia = item.liable_content
          }
          if (!item.reparationReasonList) {
            this.$set(item, 'reparationReasonList', [])
          }
          this.reparationReason(index, item.liable_content, true)
        })

        // 将转化好的数据替换图片数组
        this.after_sale_detail.client_images = tiHuan;
        this.after_sale_detail.admin_images = tiHuanC;
      });
    },
    // 把图片拼回接口需要的格式
    assemblePictures(imgList) {
      let returnList = []
      imgList.forEach((item) => {
        if (item.response) {
          returnList.push(item.response.data)
        } else {
          returnList.push(item.url)
        }

      })
      return returnList
    },
    // 售后费用调整明细添加数据
    addData() {
      this.after_sale_detail_fee.push({
        z: '',
        f: '',
      });
    },
    // 售后费用调整明细删除数据
    deleteData(item, index) {
      this.$confirm(
        // 文本:是否确认删除
        this.$t("message.whetherToConfirmTheDeletion"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      ).then(() => {
        this.after_sale_detail_fee.splice(index, 1);
      });
    },
    // 获取售后原因列表
    getconfigReasonList() {
      this.$api.capitalApi.configReasonList().then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        //接下来的操作
        this.configReasonList = res.data;
      });
    },
    // 获取金额调整列表
    configFeeTypeList() {
      this.$api.capitalApi.configFeeTypeList().then((res) => {
        ////console.log('事件名',res)
        if (res.code != 0) return this.$message.error(res.data.msg);
        //接下来的操作
        this.configFeeType = res.data;
      });
    },
    // 计算合计金额
    amountTotal(list, iSIIndex) {
      this.reparations[iSIIndex].actual_amount = 0
      this.reparations[iSIIndex].team_amount = 0

      list.forEach(item => {
        this.reparations[iSIIndex].actual_amount += item.amount - 0
        this.reparations[iSIIndex].team_amount += item.amount - 0
      })
      this.reparations[iSIIndex].actual_amount = this.reparations[iSIIndex].actual_amount.toFixed(2)
      this.reparations[iSIIndex].team_amount = this.reparations[iSIIndex].team_amount.toFixed(2)
    },
  },
};
</script>
<style lang='scss' scoped>
* {
  box-sizing: border-box;
}

.showText {
  pointer-events: none;

  /deep/ * {
    background-color: transparent;
    border: none;
    text-align: center;
  }

  /deep/.el-input__suffix {
    display: none;
  }
}

.No_data {
  margin: 20px auto;
  text-align: center;
  font-size: 20px;
}

.flex05 {
  flex: 0.5;
}

.flex15 {
  flex: 1.5;
}

.flex2 {
  flex: 2;
}

.modelRow {
  width: 1760px;
  margin: 0 auto 40px;
  display: flex;

  .after-salesNumber {
    padding: 30px 40px 30px 35px;
    width: 680px;
    background: #f8f8f8;
    border-radius: 8px;
    margin-right: 40px;

    p {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      line-height: 20px;

      >span {
        &:first-child {
          display: inline-block;
          width: 150px;
        }
      }

      .operatorsList {
        span {
          margin-right: 15px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .el-button {
      width: 150px;
      height: 32px;
      border-radius: 4px;
      padding: 0;

      /deep/ span {
        display: inline-flex;
        justify-content: center;
        align-items: center;

        img {
          margin-right: 10px;
        }
      }
    }

    .ChatworkBtn {
      background-color: #e65244;
      border-color: #e65244;
    }

    .Rakuchat {
      background-color: #0768ab;
      border-color: #0768ab;
    }
  }

  .afterSalesReasons {
    padding: 30px 40px 30px 35px;
    flex: 1;
    background: #f8f8f8;
    border-radius: 8px;
    display: flex;

    .formBox {
      .imageUpload {
        h3 {
          font-size: 14px;
          line-height: 20px;
          margin-top: 10px;
          margin-bottom: 12px;
        }

        .imageBox {
          display: flex;
          align-items: center;
          padding: 0 16px;
          margin-bottom: 80px;

          >* {
            margin: 0 8px;
          }

          /deep/.el-upload,
          .el-upload {
            width: 80px;
            height: 80px;
            display: inline-flex;
            justify-content: center;
            align-items: center;
          }

          /deep/.el-upload-list__item {
            width: 80px;
            height: 80px;

            img {
              width: 80px;
              height: 80px;
            }
          }
        }
      }
    }

    .formBox.reasonSelection {
      margin-right: 80px;
      width: 457px;

      li {
        display: flex;
        margin-bottom: 26px;

        &:last-child {
          margin-bottom: 0;
        }

        >span {
          margin-top: 10px;
          line-height: 20px;
          display: inline-block;
          width: 117px;
          margin-right: 20px;
        }

        .el-textarea {
          /deep/.el-textarea__inner {
            width: 320px;
            height: 100px;
            border: 1px solid #edeff4;
            border-radius: 4px;
          }
        }
      }
    }
  }
}

.afterSalesCostAdjustmentDetails {
  width: 1760px;
  margin: 0 auto 40px;
  padding: 18px 40px 24px;
  background: #f8f8f8;
  border-radius: 8px;

  h3 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .textLi {

    .el-textarea,
    /deep/.el-textarea {
      width: 480px;
      height: 80px;

      .el-textarea__inner {
        height: 80px;
      }
    }
  }

  .inputLi {
    .el-input {
      width: 180px;
    }

    /deep/ input {
      height: 40px;
      background: #ffffff;
      border: 1px solid #edeff4;
      border-radius: 4px;
      text-align: center;
    }
  }

  .totalAdjustmentsText {
    text-align: right;
    padding: 25px 0px 25px 0;
    border: none;
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
  }
}

.afterSalesCostAdjustmentDetailsOperate {
  height: 64px;
  background: #edeff4;
  border-radius: 0px 0px 8px 8px;
  padding: 16px 40px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.indemnityStatementInformation {
  width: 1760px;
  min-height: 576px;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 24px 40px 40px;
  margin: 40px auto;
  display: flex;

  h3 {
    line-height: 20px;
    min-height: 40px;

    span {
      margin-right: 80px;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .indemnityBill {
    .infoBoxGroup {
      width: 520px;
      margin-right: 40px;

      .infoBox {
        margin-bottom: 30px;
        border: solid 1px;

        li {
          border: solid 1px;
          display: flex;
          align-items: center;

          >label {
            width: 150px;
            text-align: center;
          }

          >div {
            padding: 14px 0px 14px 30px;
            height: 100%;
            min-height: 42px;
            border-left: solid 1px;
          }
        }

        .categoryOfResponsiblePersonBox {
          /deep/.el-radio {
            margin-right: 10px;
          }

          p {
            height: 42px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 20px;
          }

          .el-input {
            width: 180px;
          }

          /deep/.el-input__inner {
            width: 180px;
          }
        }
      }
    }
  }

  .detailsOfExpensesToBear {
    flex: 1;

    h3 {
      text-align: right;
    }

    .total {
      display: flex;
      margin-bottom: 10px;

      .item {
        flex: 1;
        font-size: 16px;
        font-weight: bold;
        display: flex;
        line-height: 40px;

        /deep/.el-input {
          width: 100px;
          margin: 0 10px;
        }
      }
    }

    .numBox,
    /deep/.numBox {
      input {
        text-align: center;
      }
    }

    .table {
      min-height: 470px;
    }

    ul {
      padding: 0;

      li {
        min-height: 70px;
        padding: 0 20px;
      }
    }
  }

  .bearTheCostBreakdownOperation {
    margin-top: 12px;
    min-height: 64px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #EDEFF4;
    border-radius: 0px 0px 8px 8px;
    padding: 16px 40px;
  }

  .should_amount {
    width: 80%;
    height: 38px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
}
</style>
